import styled from 'styled-components';
import {theme} from '@styles/theme';

export const ModalWrapper = styled.div`
  width: 432px;
`;

export const ModalContent = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 24px;
  padding: 24px;
  justify-content: center;
  border-top: 1px solid ${theme.colors.basic06};
`;

export const AttentionWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
`;

export const AttentionIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  width: 40px;
  height: 40px;
  border: 1px solid ${theme.colors.basic06};
  border-radius: 40px;
`;

export const AttentionTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SelectedUsersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px;
  gap: 8px;
  background-color: ${theme.colors.basic07};
  border-radius: ${theme.roundedMedium};
  border: 0;
`;

export const SelectedUsersRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
`;

export const SelectedUsersInfoWrapper = styled.div`
  display: flex;
  gap: 4px;
`;

export const SelectedUsersTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
